module.exports = __webpack_public_path__ + "09602d9.woff2";